import { render, staticRenderFns } from "./IndexTableRow.vue?vue&type=template&id=7085d520&scoped=true"
import script from "./IndexTableRow.vue?vue&type=script&lang=js"
export * from "./IndexTableRow.vue?vue&type=script&lang=js"
import style0 from "./IndexTableRow.vue?vue&type=style&index=0&id=7085d520&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7085d520",
  null
  
)

export default component.exports